import { render, staticRenderFns } from "./TaskConfigEditView.vue?vue&type=template&id=59330331&"
import script from "./TaskConfigEditView.vue?vue&type=script&lang=js&"
export * from "./TaskConfigEditView.vue?vue&type=script&lang=js&"
import style0 from "./TaskConfigEditView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports